import React from "react";
import HighlightText from "../../../components/core/HomePage/HighlightText";
import CTAButton from "../../../components/core/HomePage/Button";

const LearningGridArray = [
  {
    order: -1,
    heading: "World-Class Learning for",
    highlightText: "Anyone, Anywhere",
    description:
      "Studynotion partners with more than 275+ leading universities and companies to bring flexible, affordable, job-relevant online learning to individuals and organizations worldwide.",
    BtnText: "Learn More",
    BtnLink: "/",
  },
  {
    order: 1,
    heading: "Curriculum Based on Industry Needs",
    description:
      "Save time and money! The Belajar curriculum is made to be easier to understand and in line with industry needs.",
  },
  {
    order: 2,
    heading: "Our Learning Methods",
    description:
      "Studynotion partners with more than 275+ leading universities and companies to bring",
  },
  {
    order: 3,
    heading: "Certification",
    description:
      "Studynotion partners with more than 275+ leading universities and companies to bring",
  },
  {
    order: 4,
    heading: `Rating "Auto-grading"`,
    description:
      "Studynotion partners with more than 275+ leading universities and companies to bring",
  },
  {
    order: 5,
    heading: "Ready to Work",
    description:
      "Studynotion partners with more than 275+ leading universities and companies to bring",
  },
];

const LearningGrid = () => {
  return (
    <div className="grid mx-auto grid-col-1 lg:grid-cols-4 mb-10 mt-10 gap-1 w-11/12">
     {
      LearningGridArray.map((card,index)=>{
        return(
          <div 
           key={index}
           className={` p-4 ${index===0 && "lg:col-span-2"}
            ${
              card.order%2 ===1 ? "bg-richblack-800" :"bg-richblack-600"
            }
            ${
              card.order===3 && "lg:col-start-2"
            }
            ${
              card.order <0  && "bg-transparent"
            }
           `}
          >
          {
            card.order < 0 ?
            (
            <div >   
             <div>
                   <h1>{card.heading} </h1>
                  <HighlightText text={card.highlightText}/>
                  <p>{card.description}</p>
                  <CTAButton linkto={card.BtnLink} active={true}>
                    {card.BtnText}
                  </CTAButton>
              </div>
              
            </div>
            ):(
              <div>
                 <h1>{card.heading}</h1>
                 <p>{card.description}</p>
              </div>
            )
          }


          </div>  
        )
      })
     }
    </div>
  )
};

export default LearningGrid;